<template>
  <div>
    <file-uploader :compMode="compMode" entite="Event"></file-uploader>

    <div class="card mb-3">
      <div class="card-header">
        <i class="fa fa-briefcase"></i>
        <span
          v-if="compMode == CRUDMODE.CREATE || compMode == CRUDMODE.COPY"
        >{{ $t('event.create.title') }}</span>
        <span v-if="compMode == CRUDMODE.UPDATE">{{ $t('event.edit.title') }}</span>
        <span v-if="compMode == CRUDMODE.READ">{{ $t('event.view.title') }}</span>
        <toggle-button
          style="margin-left:20px"
          v-model="event.displayInWebsite"
          :sync="true"
          :width="200"
          :height="30"
          :font-size="14"
          :labels="{checked: 'Affiché sur le site web', unchecked: 'Masqué sur le site web'}"
        />
      </div>
      <div class="card-body">
        <errorMessage v-bind:message="error"></errorMessage>

        <form>
          <photo-uploader
            :compMode="compMode"
            entite="Event"
            :fileType="fileType_eventImage"
            ref="photoUploader"
          ></photo-uploader>
          <div class="row">
            <div class="form-group col-md-4">
              <label for="typeInput">{{ $t('event.form.type') }}*</label>
              <input
                type="hidden"
                name="type_validate"
                v-model="type_validate"
                v-validate="'required'"
              />
              <select
                v-model="event.type"
                class="form-control"
                id="typeInput"
                v-bind:placeholder="$t('event.form.type')"
              >
                <option v-for="s in eventTypes" :value="s.item1" :key="s.item1">{{s.item2}}</option>
              </select>
              <span
                class="text-danger"
                v-if="errors.has('type_validate')"
              >{{ $t('validations.required') }}.</span>
            </div>

            <div class="form-group col-md-4" v-if="typeIn(1, 4)">
              <label for="detailType">{{ $t('event.form.detailType') }}</label>
              <input
                type="hidden"
                name="type_validate"
                v-model="detailType_validate"
                v-validate="'required'"
              />
              <select
                v-model="event.detailType"
                class="form-control"
                id="detailType"
                v-bind:placeholder="$t('event.form.detailType')"
              >
                <option
                  v-for="s in eventDetailTypesFiltered"
                  :value="s.item1"
                  :key="s.item1"
                >{{s.item2}}</option>
              </select>
              <span
                class="text-danger"
                v-if="errors.has('detailType_validate')"
              >{{ $t('validations.required') }}.</span>
            </div>

            <div class="form-group col-md-4" v-if="typeIn(1)">
              <label for="nameInput">{{ $t('event.form.name') }}</label>
              <input
                v-model.trim="event.name"
                name="name"
                type="text"
                class="form-control"
                id="nameInput"
                v-bind:placeholder="$t('event.form.name')"
              />
            </div>

            <!-- <div class="form-group col-md-4" v-if="typeIn(1,2,3,4)">
              <label for="date">{{ $t('event.form.date') }}</label>
              <moment-date-picker v-model="event.date" :required="true"></moment-date-picker>
            </div> -->

            <div class="form-group col-md-4" v-if="typeIn(1, 4, 5)">
              <label for="region">{{ $t('event.form.region') }}</label>
              <select
                v-model="event.region"
                class="form-control"
                id="region"
                v-bind:placeholder="$t('event.form.region')"
              >
                <option v-for="s in regions" :value="s.item1" :key="s.item1">{{s.item2}}</option>
              </select>
            </div>

            <div class="form-group col-md-4" v-if="typeIn(4)">
              <label for="place">{{ $t('event.form.organizerType') }}</label>
              <select
                v-model="event.personTypeOrganizer"
                :data-vv-name="'personType'"
                class="form-control"
                id="typeInput"
                :placeholder="$t('event.form.organizerType')"
              >
                <option v-for="s in personTypes" :value="s.item1" :key="s.item1">{{s.item2}}</option>
              </select>
            </div>

            <div class="form-group col-md-4" v-if="typeIn(4)">
              <label for="place">{{ $t('event.form.organizer') }}</label>
              <member-multiselect
                v-if="event.personTypeOrganizer == 1"
                :members="members"
                :model="event.memberOrganizer"
                @update="f=> changeValue('memberOrganizer', f)"
              ></member-multiselect>
              <user-multiselect
                v-if="event.personTypeOrganizer == 2"
                :model="event.userOrganizer"
                @update="f=> changeValue('userOrganizer', f)"
              ></user-multiselect>
              <entrepreneur-multiselect
                v-if="event.personTypeOrganizer == 3"
                :model="event.entrepreneurOrganizer"
                @update="f=> changeValue('entrepreneurOrganizer', f)"
              ></entrepreneur-multiselect>
            </div>

            <div class="form-group col-md-4" v-if="typeIn(2)">
              <label for="meetingLocation">{{ $t('member.form.meetingLocation') }}</label>
              <select v-model="event.meetingLocation" class="form-control" id="meetingLocation">
                <option v-for="l in locations" :value="l.key" :key="l.key">{{l.value}}</option>
              </select>
              <span
                class="text-danger"
                v-if="errors.has('meetingLocation')"
              >{{ errors.first('meetingLocation') }}</span>
            </div>
          </div>

          <div class="row" v-if="typeIn(1, 4)">
            <div class="form-group col-md-12">
              <label for="place">{{ $t('event.form.place') }}</label>
              <textarea
                v-model.trim="event.place"
                name="place"
                type="text"
                class="form-control"
                id="place"
                :placeholder="$t('event.form.place')"
              ></textarea>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-4" v-if="typeIn(1)">
              <label for="nameInput">{{ $t('event.form.organizer') }}</label>
              <partner-multiselect
                :model="event.partnerOrganizer"
                @update="f=> changeValue('partnerOrganizer', f)"
              ></partner-multiselect>
            </div>

            <div class="form-group col-md-4" v-if="typeIn(1)">
              <label for="natureOfOrganization">{{ $t('event.form.natureOfOrganization') }}</label>
              <select
                v-model="event.natureOfOrganization"
                class="form-control"
                id="natureOfOrganization"
                v-bind:placeholder="$t('event.form.natureOfOrganization')"
              >
                <option
                  v-for="s in natureOfOrganizations"
                  :value="s.item1"
                  :key="s.item1"
                >{{s.item2}}</option>
              </select>
              <span
                class="text-danger"
                v-if="errors.has('natureOfOrganization')"
              >{{ errors.first('natureOfOrganization') }}</span>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-4" v-if="typeIn(1, 4)">
              <label for="participantCount">{{ $t('event.form.participantCount') }}</label>
              <select
                v-model="event.participantCount"
                class="form-control"
                id="participantCount"
                v-bind:placeholder="$t('event.form.participantCount')"
              >
                <option v-for="s in participantCounts" :value="s.item1" :key="s.item1">{{s.item2}}</option>
              </select>
              <span
                class="text-danger"
                v-if="errors.has('participantCount')"
              >{{ errors.first('participantCount') }}</span>
            </div>

            <div class="form-group col-md-4" v-if="typeIn(1)">
              <label for="businessLevel">{{ $t('event.form.businessLevel') }}</label>
              <select
                v-model="event.businessLevel"
                class="form-control"
                id="businessLevel"
                v-bind:placeholder="$t('event.form.businessLevel')"
              >
                <option v-for="s in businessLevels" :value="s.item1" :key="s.item1">{{s.item2}}</option>
              </select>
              <span
                class="text-danger"
                v-if="errors.has('businessLevel')"
              >{{ errors.first('businessLevel') }}</span>
            </div>

            <div class="form-group col-md-4" v-if="typeIn(1)">
              <label for="sectorOfActivityInput">{{ $t('event.form.sectorOfActivity') }}</label>
              <select
                v-model="event.sectorOfActivity"
                v-validate="'required'"
                class="form-control"
                id="sectorOfActivityInput"
              >
                <option v-for="s in sectors" :value="s.item1" :key="s.item1">{{s.item2}}</option>
              </select>
              <span
                class="text-danger"
                v-if="errors.has('sectorOfActivity')"
              >{{ errors.first('sectorOfActivity') }}</span>
            </div>

            <div class="form-group col-md-4" v-if="typeIn(4)">
              <label for="type">{{ $t('event.form.project.type') }}</label>
              <select
                v-model="event.projectType"
                :data-vv-name="'type'"
                v-validate="'required'"
                class="form-control"
                id="typeInput"
                :placeholder="$t('event.form.project.type')"
              >
                <option v-for="s in projectTypes" :value="s.item1" :key="s.item1">{{s.item2}}</option>
              </select>
            </div>
          </div>

          <create-custom-event
            v-if="typeIn(1,2,3,4,5)"
            :compMode="compMode"
            :event="event"
            :members="members"
          ></create-custom-event>

          <create-event-project
            v-if="typeIn(3)"
            :compMode="compMode"
            :eventProjects="event.eventProjects"
            :projectTypes="projectTypes"
          ></create-event-project>

          <create-event-person
            v-if="typeIn(2,3,4)"
            :compMode="compMode"
            :eventPersons="event.eventPersons"
            :members="members"
          ></create-event-person>

          <create-event-interest
            v-if="typeIn(2) && compMode != CRUDMODE.CREATE && compMode != CRUDMODE.COPY"
            :compMode="compMode"
            :eventPersons="event.eventPersons"
            :eventProjects="event.eventProjects"
          ></create-event-interest>

          <div class="row" v-if="typeIn(2,3,5)">
            <div class="form-group col-md-4">
              <label for="hidePresenceButton">{{ $t('event.form.hidePresenceButton') }}</label>
              <div class="col-9">
                <label class="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    name="hidePresenceButton"
                    value="1"
                    class="custom-control-input"
                    id="hidePresenceButton"
                    v-model="event.hidePresenceButton"
                  />
                  <span class="custom-control-indicator"></span>
                  <span class="custom-control-label">{{$t("yes")}}</span>
                </label>
              </div>
            </div>
          </div>

          <div class="row" v-if="typeIn(1,2,3,4)">
            <div class="form-group col-md-12">
              <label for="commentsInput">{{ $t('event.form.comments') }}</label>
              <textarea
                v-model.trim="event.comments"
                name="comments"
                type="text"
                class="form-control"
                id="commentsInput"
                :placeholder="$t('event.form.comments')"
              ></textarea>
            </div>
          </div>

          <a
            @click="createEvent"
            v-if="compMode == CRUDMODE.CREATE || compMode == CRUDMODE.COPY"
            id="addButton"
            class="btn btn-primary"
          >{{ $t('form.create_button') }}</a>

          <a
            @click="editEvent"
            v-if="compMode == CRUDMODE.UPDATE"
            id="editButton"
            class="btn btn-primary"
          >{{ $t('form.edit_button') }}</a>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  EventServiceClient,
  PersonServiceClient,
  CompanyServiceClient,
  AddressServiceClient,
  PartnerServiceClient,
  MemberServiceClient,
  EventDto,
  AddressDto,
  LocalizableStringDto,
} from '../../shared/service-clients/service-clients'
import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
import CrudMixin from '../../shared/Mixin/CrudMixin'
import moment from 'moment'
import Enum from '@/shared/enum'
import PhotoUploader from '../../shared/components/PhotoUploader.vue'
import CreateEventProject from './CreateEventProject'
import CreateEventPerson from './CreateEventPerson'
import CreateEventInterest from './CreateEventInterest'
import CreateCustomEvent from './CreateCustomEvent'
import MemberMultiselect from '../../shared/multiselect/MemberMultiselect'
import EntrepreneurMultiselect from '../../shared/multiselect/EntrepreneurMultiselect'
import UserMultiselect from '../../shared/multiselect/UserMultiselect'
import PartnerMultiselect from '../../shared/multiselect/PartnerMultiselect'
import {ToggleButton} from 'vue-js-toggle-button'
export default {
  name: 'CreateEvent',
  mixins: [CrudMixin],
  inject: ['$validator'],
  data() {
    let dto = new EventDto()
    dto.eventPersons = []
    dto.eventProjects = []
    dto.displayInWebsite = true
    dto.title = new LocalizableStringDto()
    dto.description = new LocalizableStringDto()
    dto.shortDescription = new LocalizableStringDto()

    return {
      event: dto,
      businessLevels: [],
      eventDetailTypes: [],
      eventTypes: [],
      natureOfOrganizations: [],
      participantCounts: [],
      sectors: [],
      regions: [],
      members: [],
      personTypes: [],
      projectTypes: [],
      locations: [],
    }
  },
  computed: {
    fileType_eventImage: function() {
      return Enum.FileType.EVENTIMAGE
    },
    eventDetailTypesFiltered: function() {
      if (this.eventDetailTypes == null) return []
      let filtre = []
      if (this.event.type == 1)
        // externe
        filtre = [1, 2, 3, 4, 5]
      else if (this.event.type == 4)
        // interne
        filtre = [3, 6, 7, 8, 9, 10, 11]

      return _.filter(this.eventDetailTypes, f => _.some(filtre, s => s == f.item1))
    },
    type_validate: function() {
      return this.event.type == 0 ? null : this.event.type
    },
    detailType_validate: function() {
      return this.event.detailType == 0 ? null : this.event.detailType
    },
  },
  methods: {
    changeValue: function(field, value) {
      this.event[field] = value
    },
    typeIn: function(...types) {
      return _.some(types, s => s == this.event.type)
    },
    cleanEntity: function() {
      let cleanEntity = this.cleanFields(_.cloneDeep(this.event))

      if (cleanEntity.eventPersons == null) {
        cleanEntity.eventPersons = []
      } else {
        for (var ix = 0; ix < cleanEntity.eventPersons.length; ix++) {
          if (cleanEntity.eventPersons[ix].personType == 1 && cleanEntity.eventPersons[ix].member != undefined) {
            cleanEntity.eventPersons[ix].memberId = cleanEntity.eventPersons[ix].member.id
            cleanEntity.eventPersons[ix].partnerId = null
            cleanEntity.eventPersons[ix].associatedUserId = null
            cleanEntity.eventPersons[ix].entrepreneurId = null
          } else if (cleanEntity.eventPersons[ix].personType == 2 && cleanEntity.eventPersons[ix].associatedUser != undefined) {
            cleanEntity.eventPersons[ix].memberId = null
            cleanEntity.eventPersons[ix].partnerId = null
            cleanEntity.eventPersons[ix].associatedUserId = cleanEntity.eventPersons[ix].associatedUser.id
            cleanEntity.eventPersons[ix].entrepreneurId = null
          } else if (cleanEntity.eventPersons[ix].personType == 3 && cleanEntity.eventPersons[ix].entrepreneur != undefined) {
            cleanEntity.eventPersons[ix].memberId = null
            cleanEntity.eventPersons[ix].partnerId = null
            cleanEntity.eventPersons[ix].associatedUserId = null
            cleanEntity.eventPersons[ix].entrepreneurId = cleanEntity.eventPersons[ix].entrepreneur.id
          } else if (cleanEntity.eventPersons[ix].personType == 4 && cleanEntity.eventPersons[ix].partner != undefined) {
            cleanEntity.eventPersons[ix].memberId = null
            cleanEntity.eventPersons[ix].partnerId = cleanEntity.eventPersons[ix].partner.id
            cleanEntity.eventPersons[ix].associatedUserId = null
            cleanEntity.eventPersons[ix].entrepreneurId = null
          }
          cleanEntity.eventPersons[ix].member = null
          cleanEntity.eventPersons[ix].associatedUser = null
          cleanEntity.eventPersons[ix].entrepreneur = null
          cleanEntity.eventPersons[ix].partner = null
        }
      }

      if (cleanEntity.eventProjects == null) {
        cleanEntity.eventProjects = []
      }

      if (this.typeIn(4)) {
        if (cleanEntity.personTypeOrganizer == 1 && cleanEntity.memberOrganizer != null) {
          cleanEntity.memberOrganizerId = cleanEntity.memberOrganizer.id
          cleanEntity.userOrganizerId = null
          cleanEntity.partnerOrganizerId = null
          cleanEntity.entrepreneurOrganizerId = null
        }
        if (cleanEntity.personTypeOrganizer == 2 && cleanEntity.userOrganizer != null) {
          cleanEntity.userOrganizerId = cleanEntity.userOrganizer.id
          cleanEntity.memberOrganizerId = null
          cleanEntity.partnerOrganizerId = null
          cleanEntity.entrepreneurOrganizerId = null
        }
      } else if (this.typeIn(1) && cleanEntity.partnerOrganizer != null) {
        cleanEntity.partnerOrganizerId = cleanEntity.partnerOrganizer.id
        cleanEntity.memberOrganizerId = null
        cleanEntity.userOrganizerId = null
        cleanEntity.entrepreneurOrganizerId = null
      } else {
        cleanEntity.memberOrganizerId = null
        cleanEntity.userOrganizerId = null
        cleanEntity.partnerOrganizerId = null
        cleanEntity.entrepreneurOrganizerId = null
      }

      cleanEntity.memberOrganizer = null
      cleanEntity.userOrganizer = null
      cleanEntity.partnerOrganizer = null
      cleanEntity.entrepreneurOrganizer = null

      let cleanRoles = []
      if (cleanEntity.roles) {
        for (var index = 0; index < cleanEntity.roles.length; index++) {
          cleanRoles.push(cleanEntity.roles[index].item1)
        }
      }

      cleanEntity.roles = cleanRoles

      return cleanEntity
    },
    createEvent: function() {
      this.$validator
        .validateAll()
        .then(result => {
          let self = this
          if (result && this.ready) {
            let eventService = ServiceFactory.create(EventServiceClient)

            eventService
              .create(this.cleanEntity())
              .then(function(res) {
                self.persistFiles(res.id)
                self.$refs.photoUploader.persistPhoto(res.id)
              })
              .then(res => {
                this.$swal('Succès', this.$t('event.create.succes'), 'success')
                this.$router.push({path: '/events'})
              })
              .catch(err => {
                self.processError(err, self)
              })
          } else {
            console.log(self.errors)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    editEvent: function() {
      this.$validator
        .validateAll()
        .then(result => {
          let self = this

          if (result && this.ready) {
            let eventService = ServiceFactory.create(EventServiceClient)

            eventService
              .update(this.cleanEntity())
              .then(function(res) {
                self.persistFiles(self.$route.params.id)
                self.$refs.photoUploader.persistPhoto(self.$route.params.id)
              })
              .then(res => {
                this.$swal('Succès', this.$t('event.edit.succes'), 'success')
                this.$router.push({path: '/events'})
              })
              .catch(err => {
                self.processError(err, self)
              })
          } else {
            console.log(self.errors)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    fetchData: function() {
      let eventService = ServiceFactory.create(EventServiceClient)
      let companyService = ServiceFactory.create(CompanyServiceClient)
      let service = ServiceFactory.create(AddressServiceClient)
      let memberService = ServiceFactory.create(MemberServiceClient)

      let self = this
      let promisseAll

      let getLocations = service.getLocations()
      let getBusinessLevel = eventService.getBusinessLevel()
      let getEventDetailType = eventService.getEventDetailType()
      let getEventType = eventService.getEventType()
      let getNatureOfOrganization = eventService.getNatureOfOrganization()
      let getParticipantCount = eventService.getParticipantCount()
      let getCompanySector = companyService.getSectorOfActivity()
      let getRegions = service.getRegions()
      let memberGetAll = memberService.getAll(8, '', '', 0, 1000)
      let getPersonType = eventService.getEventPersonType()

      let getProjectType = eventService.getProjectType()

      getProjectType.then(res => {
        self.projectTypes = res
      })
      getBusinessLevel.then(res => {
        self.businessLevels = res
      })
      getEventDetailType.then(res => {
        self.eventDetailTypes = res
      })
      getEventType.then(res => {
        self.eventTypes = _.filter(res, f => f.item1 != 1 && f.item1 != 4)
      })
      getNatureOfOrganization.then(res => {
        self.natureOfOrganizations = res
      })
      getParticipantCount.then(res => {
        self.participantCounts = res
      })
      getCompanySector.then(res => {
        self.sectors = res
      })
      getRegions.then(res => {
        self.regions = res
      })
      memberGetAll.then(res => {
        self.members = res.items
      })
      getPersonType.then(res => {
        self.personTypes = _.filter(res, f => f.item1 != 0 && f.item1 != 4)
      })
      getLocations.then(res => {
        self.locations = res
      })

      if (this.compMode != Enum.Mode.CREATE) {
        let getEvent = eventService.get(this.$route.params.id)
        getEvent
          .then(res => {
            self.event = res
            if (self.event.eventProjects == null) {
              self.event.eventProjects = []
            }

            if (self.event.eventPersons == null) {
              self.event.eventPersons = []
            }

            self.checkCopyMode(self.event)
          })
          .catch(err => {
            console.log(err)
          })

        promisseAll = Promise.all([
          getBusinessLevel,
          getEventDetailType,
          getEventType,
          getNatureOfOrganization,
          getParticipantCount,
          getEvent,
          memberGetAll,
          getPersonType,
          getProjectType,
          getLocations,
        ])
      } else {
        promisseAll = Promise.all([
          memberGetAll,
          getBusinessLevel,
          getEventDetailType,
          getEventType,
          getNatureOfOrganization,
          getParticipantCount,
          getPersonType,
          getProjectType,
          getLocations,
        ])
      }

      promisseAll.then(v => {
        self.ready = true
      })
    },
  },
  components: {
    CreateEventProject,
    CreateEventPerson,
    CreateEventInterest,
    CreateCustomEvent,
    MemberMultiselect,
    EntrepreneurMultiselect,
    UserMultiselect,
    PartnerMultiselect,
    ToggleButton,
    'photo-uploader': PhotoUploader,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.btn-primary {
  color: #fff !important;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/events/CreateEvent.vue